import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_b_button = _resolveComponent("b-button")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.menuClass)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['dropdown-toggle', {'hide-caret': _ctx.noCaret}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.show = !_ctx.state.show)),
      onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseOver && _ctx.handleMouseOver(...args)))
    }, [
      _renderSlot(_ctx.$slots, "button-content", {}, () => [
        (_ctx.isButton)
          ? (_openBlock(), _createBlock(_component_b_button, {
              key: 0,
              class: _normalizeClass(_ctx.btnClass),
              variant: "secondary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                _createVNode(_component_font_awesome_icon, { icon: _ctx.displayIcon }, null, 8, ["icon"])
              ]),
              _: 1
            }, 8, ["class"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.title), 1))
      ], true)
    ], 34),
    (_ctx.state.show)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          class: "dropdown-menu",
          style: _normalizeStyle(_ctx.menuStyle),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
        }, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 4))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_outside, _ctx.handleClickOutside]
  ])
}